import React from 'react';

const Row = ({ params, row, sources, affids }) => {
    let td = getValues(params, row, sources, affids);

    return (
        <tr>{td}</tr>
    );
};

function getValues(params, row, sources, affids) {
    return params.map((param, index) => {
        let value = row[index];

        if(param === 'source') value = sources[value];
        if(param === 'affid') value = affids[value];

        return(<td key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderFillRate/components/Table/components/Row/index.js